

export class LogReqChangeUserWatch {
   public reqChangeUserWatchId: number = 0;
   public watcherUserId: number = 0;
   public watcheeEmpId: number = 0;
   public dailyNotice: boolean = null;
   public allChangeNotice: boolean = null;
   public tenantId: number = 0;
}